module.exports = __webpack_public_path__ + "img/1.6a7216bc.png";